/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// node_modules
import React, { Component } from "react";

// components - molecules
import ErrorMessage from "components/molecules/ErrorMessage/ErrorMessage.js";

// components - layouts
import Modal from "components/layouts/Modal/Modal.js";

class ErrorModal extends Component {
  constructor(props) {
    super(props);
    // @props: className - String
    // @props: height: Number | String
    // @props: style - Object
    // @props: zIndex - Number
    // @props: onClose - Function

    this.state = {};
  }

  render() {
    const { props } = this;
    const { className, error, style, onClose } = props;

    return (
      <Modal
        className={className || "align-items-center d-flex justify-content-center"}
        disableCloseButton={true}
        style={style}
      >
        <ErrorMessage onClose={onClose}>
          {error}
        </ErrorMessage>
      </Modal>
    );
  }
}
export default ErrorModal;
